// src/pages/ClosureReport.js

import React, {
  useState,
  useEffect,
} from "react";

import {
  useLocation,
} from "react-router-dom";

import {
  FiEdit,
  FiTrash2,
  FiPlus,
  FiX,
} from "react-icons/fi";

import * as XLSX from "xlsx";

import jsPDF from "jspdf";

import autoTable from "jspdf-autotable";

import dayjs from "dayjs";

import {
  getData,
  postData,
  putData,
  deleteData,
} from "../../../services/FetchNodeservices";

export default function ClosureReport() {

  // =================================================
  // LOCATION
  // =================================================

  const location =
    useLocation();

  // =================================================
  // STATES
  // =================================================

  const [closureData, setClosureData] =
    useState([]);

  const [selectedRows, setSelectedRows] =
    useState([]);

  const [openForm, setOpenForm] =
    useState(false);

  const [editRow, setEditRow] =
    useState(null);

  // =================================================
  // FILTERS
  // =================================================

  const currentMonthName =
    new Date().toLocaleString(
      "default",
      {
        month: "long",
      }
    );

  const [filterMonth, setFilterMonth] =
    useState("");

  const [filterCompany, setFilterCompany] =
    useState("");

  const [filterStatus, setFilterStatus] =
    useState("");

  const [filterPayment, setFilterPayment] =
    useState("");

  // =================================================
  // FORM
  // =================================================

  const [formData, setFormData] =
    useState({

      month: "",

      company: "",

      team_lead: "",

      associate_name: "",

      candidate_name: "",

      contact_no: "",

      designation: "",

      location: "",

      doj: "",

      status_jo: "",

      ctc_offered: "",

      pct: "",

      amount: "",

      bill_status: "",

      payment_status: "",

      joining_month: "",

      vertical: "",
    });

  // =================================================
  // COLUMNS
  // =================================================

  const columns = [

    "month",

    "company",

    "team_lead",

    "associate_name",

    "candidate_name",

    "contact_no",

    "designation",

    "location",

    "doj",

    "status_jo",

    "ctc_offered",

    "pct",

    "amount",

    "bill_status",

    "payment_status",

    "joining_month",

    "vertical",
  ];

  // =================================================
  // AUTO CURRENT MONTH FILTER
  // =================================================

  useEffect(() => {

    const params =
      new URLSearchParams(
        location.search
      );

    const filter =
      params.get("filter");

    if (
      filter ===
      "currentMonth"
    ) {

      setFilterMonth(
        currentMonthName
      );
    }

  }, [location.search]);

  // =================================================
  // FETCH DATA
  // =================================================

  useEffect(() => {

    fetchClosureData();

  }, []);

  const fetchClosureData =
    async () => {

      try {

        const data =
          await getData(
            "clouserreport/fetch"
          );

        if (
          data?.status
        ) {

          setClosureData(
            data.data || []
          );
        }

      } catch (error) {

        console.log(error);
      }
    };

  // =================================================
  // UNIQUE
  // =================================================

  const unique = (
    key
  ) => [

    ...new Set(

      closureData
        .map(
          (x) => x[key]
        )
        .filter(Boolean)
    ),
  ];

  // =================================================
  // FILTERED DATA
  // =================================================

  const filtered =
    closureData.filter(
      (row) =>

        (!filterMonth ||
          row.month ===
            filterMonth) &&

        (!filterCompany ||
          row.company ===
            filterCompany) &&

        (!filterStatus ||
          row.status_jo ===
            filterStatus) &&

        (!filterPayment ||
          row.payment_status ===
            filterPayment)
    );

  // =================================================
  // TOGGLE
  // =================================================

  const toggleRow =
    (id) => {

      setSelectedRows(
        (prev) =>

          prev.includes(id)

            ? prev.filter(
                (x) =>
                  x !== id
              )

            : [
                ...prev,
                id,
              ]
      );
    };

  const toggleAll =
    () => {

      selectedRows.length ===
        filtered.length

        ? setSelectedRows(
            []
          )

        : setSelectedRows(
            filtered.map(
              (r) => r.id
            )
          );
    };

  // =================================================
  // EXPORT EXCEL
  // =================================================

  const exportExcel =
    () => {

      const ws =
        XLSX.utils.json_to_sheet(
          filtered
        );

      const wb =
        XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        wb,
        ws,
        "ClosureReport"
      );

      XLSX.writeFile(
        wb,
        "ClosureReport.xlsx"
      );
    };

  // =================================================
  // EXPORT PDF
  // =================================================

  const exportPDF =
    () => {

      const doc =
        new jsPDF();

      doc.text(
        "Closure Report",
        15,
        10
      );

      autoTable(doc, {

        head: [
          columns.map(
            (c) =>
              c.toUpperCase()
          ),
        ],

        body:
          filtered.map(
            (row) =>
              columns.map(
                (c) =>
                  row[c] ||
                  ""
              )
          ),

        styles: {
          fontSize: 7,
        },
      });

      doc.save(
        "ClosureReport.pdf"
      );
    };

  // =================================================
  // OPEN MODAL
  // =================================================

  const openModal =
    (row = null) => {

      setEditRow(row);

      setFormData(

        row || {

          month: "",

          company: "",

          team_lead: "",

          associate_name: "",

          candidate_name: "",

          contact_no: "",

          designation: "",

          location: "",

          doj: "",

          status_jo: "",

          ctc_offered: "",

          pct: "",

          amount: "",

          bill_status: "",

          payment_status: "",

          joining_month: "",

          vertical: "",
        }
      );

      setOpenForm(true);
    };

  // =================================================
  // SAVE
  // =================================================

  const saveForm =
    async () => {

      if (
        editRow
      ) {

        await putData(

          `clouserreport/update/${editRow.id}`,

          {
            ...formData,
            user_id: 59,
          }
        );

      } else {

        await postData(
          "clouserreport/add",
          {
            ...formData,
            user_id: 59,
          }
        );
      }

      fetchClosureData();

      setOpenForm(false);
    };

  // =================================================
  // DELETE
  // =================================================

  const deleteRow =
    async (id) => {

      await deleteData(

        `clouserreport/delete/${id}`,

        {
          user_id: 59,
        }
      );

      fetchClosureData();
    };

 // =================================================
// MAIN WRAPPER
// =================================================

return (
  <div className="md:ml-72 pt-24 px-4 md:px-6 pb-8 min-h-screen text-slate-800 flex flex-col">

    {/* ================================================= */}
    {/* HEADER */}
    {/* ================================================= */}

    <div className="flex items-center justify-between mb-4 flex-shrink-0">

      <div>

        <h1 className="text-2xl font-semibold">
          Closure Report
        </h1>

        <p className="text-xs text-slate-500 mt-0.5">
          Revenue & joining tracker
        </p>
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={exportExcel}
          className="
            bg-slate-800
            hover:bg-slate-950
            text-white
            px-4
            py-2
            rounded-xl
            text-xs
            font-semibold
            transition-colors
          "
        >
          Excel
        </button>

        <button
          onClick={exportPDF}
          className="
            border
            border-slate-200
            hover:bg-slate-50
            text-slate-700
            px-4
            py-2
            rounded-xl
            text-xs
            font-semibold
            transition-colors
          "
        >
          PDF
        </button>

        <button
          onClick={() => openModal()}
          className="
            bg-indigo-600
            hover:bg-indigo-700
            text-white
            px-4
            py-2
            rounded-xl
            text-xs
            font-semibold
            flex
            items-center
            gap-1.5
            transition-colors
            shadow-sm
          "
        >
          <FiPlus />
          Add Record
        </button>
      </div>
    </div>

    {/* ================================================= */}
    {/* FILTERS */}
    {/* ================================================= */}

    <div className="glass-card p-4 mb-4 flex-shrink-0">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3.5">
        <select
          value={filterMonth}
          onChange={(e) =>
            setFilterMonth(
              e.target.value
            )
          }
          className="glass-input px-3 py-1.5 text-xs rounded-xl outline-none"
        >
          <option value="">
            Month
          </option>

          {unique(
            "month"
          ).map(
            (x) => (
              <option
                key={x}
              >
                {x}
              </option>
            )
          )}
        </select>

        <select
          value={filterCompany}
          onChange={(e) =>
            setFilterCompany(
              e.target.value
            )
          }
          className="glass-input px-3 py-1.5 text-xs rounded-xl outline-none"
        >
          <option value="">
            Company
          </option>

          {unique(
            "company"
          ).map(
            (x) => (
              <option
                key={x}
              >
                {x}
              </option>
            )
          )}
        </select>

        <select
          value={filterStatus}
          onChange={(e) =>
            setFilterStatus(
              e.target.value
            )
          }
          className="glass-input px-3 py-1.5 text-xs rounded-xl outline-none"
        >
          <option value="">
            Status
          </option>

          {unique(
            "status_jo"
          ).map(
            (x) => (
              <option
                key={x}
              >
                {x}
              </option>
            )
          )}
        </select>

        <select
          value={filterPayment}
          onChange={(e) =>
            setFilterPayment(
              e.target.value
            )
          }
          className="glass-input px-3 py-1.5 text-xs rounded-xl outline-none"
        >
          <option value="">
            Payment
          </option>

          {unique(
            "payment_status"
          ).map(
            (x) => (
              <option
                key={x}
              >
                {x}
              </option>
            )
          )}
        </select>

        <button
          onClick={() => {
            setFilterMonth("");
            setFilterCompany("");
            setFilterStatus("");
            setFilterPayment("");
          }}
          className="
            px-4
            py-1.5
            border
            border-slate-200
            hover:bg-slate-50
            rounded-xl
            text-xs
            font-semibold
            text-slate-700
            transition-colors
          "
        >
          Reset
        </button>
      </div>
    </div>

    {/* ================================================= */}
    {/* TABLE */}
    {/* ================================================= */}

    <div className="glass-card overflow-hidden flex-1 min-h-0">

      <div className="overflow-auto h-full scrollbar-thin">

        <table className="min-w-[2200px] w-full text-xs">

          <thead
            className="
              sticky
              top-0
              bg-slate-50
              border-b
              border-slate-250
              z-20
              text-slate-500
              font-bold
              uppercase
              tracking-wider
            "
          >

            <tr>

              <th className="px-4 py-3.5 text-center">

                <input
                  type="checkbox"
                  className="rounded text-indigo-600 focus:ring-indigo-500 w-4 h-4 border-slate-300"
                  checked={
                    selectedRows.length ===
                      filtered.length &&
                    filtered.length > 0
                  }
                  onChange={
                    toggleAll
                  }
                />
              </th>

              {columns.map(
                (c) => (

                  <th
                    key={c}
                    className="
                      px-4
                      py-4
                      text-left
                      text-xs
                      font-semibold
                      text-gray-500
                      uppercase
                      whitespace-nowrap
                    "
                  >
                    {c.replace(
                      /_/g,
                      " "
                    )}
                  </th>
                )
              )}

              <th
                className="
                  px-4
                  py-4
                  text-xs
                  uppercase
                  text-gray-500
                "
              >
                Action
              </th>
            </tr>
          </thead>

          <tbody>

            {filtered.map(
              (row) => (

                <tr
                  key={row.id}
                  className="
                    border-b
                    border-gray-100
                    hover:bg-[#fafafa]
                  "
                >

                  <td className="px-4 py-4">

                    <input
                      type="checkbox"
                      checked={selectedRows.includes(
                        row.id
                      )}
                      onChange={() =>
                        toggleRow(
                          row.id
                        )
                      }
                    />
                  </td>

                  {columns.map(
                    (c) => (

                      <td
                        key={c}
                        className="
                          px-4
                          py-4
                          whitespace-nowrap
                        "
                      >

                        {c ===
                        "status_jo" ? (

                          <span
                            className="
                              px-3
                              py-1
                              rounded-full
                              text-xs
                              font-medium
                              bg-green-100
                              text-green-700
                            "
                          >
                            {
                              row[c]
                            }
                          </span>

                        ) : c ===
                          "payment_status" ? (

                          <span
                            className="
                              px-3
                              py-1
                              rounded-full
                              text-xs
                              font-medium
                              bg-blue-100
                              text-blue-700
                            "
                          >
                            {
                              row[c]
                            }
                          </span>

                        ) : c ===
                          "amount" ? (

                          <span className="font-semibold">
                            ₹
                            {Number(
                              row[c] || 0
                            ).toLocaleString()}
                          </span>

                        ) : c ===
                          "doj" ? (

                          row[c]
                            ? dayjs(
                                row[c]
                              ).format(
                                "YYYY-MM-DD"
                              )
                            : "-"

                        ) : (
                          row[c]
                        )}
                      </td>
                    )
                  )}

                  <td className="px-4 py-4">

                    <div className="flex gap-2">

                      <button
                        onClick={() =>
                          openModal(
                            row
                          )
                        }
                        className="
                          w-9
                          h-9
                          rounded-xl
                          bg-black
                          text-white
                          flex
                          items-center
                          justify-center
                        "
                      >
                        <FiEdit size={14} />
                      </button>

                      <button
                        onClick={() =>
                          deleteRow(
                            row.id
                          )
                        }
                        className="
                          w-9
                          h-9
                          rounded-xl
                          border
                          border-red-200
                          text-red-500
                          flex
                          items-center
                          justify-center
                        "
                      >
                        <FiTrash2 size={14} />
                      </button>
                    </div>
                  </td>
                </tr>
              )
            )}

            {filtered.length ===
              0 && (

              <tr>

                <td
                  colSpan={
                    columns.length +
                    2
                  }
                  className="
                    text-center
                    py-20
                    text-gray-500
                  "
                >
                  No Closure Records Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);
}